import { queryOptions, useQuery } from '@tanstack/react-query'
import { InferRequestType } from 'hono/client'

import { apiClient, formatClientResponse } from '@/apiClient.ts'

type FindLogsArgs = InferRequestType<typeof apiClient.logs.$get>['query']

export const findLogsQueryOptions = (args: FindLogsArgs) =>
  queryOptions({
    queryKey: ['logs', args],
    queryFn: () =>
      apiClient.logs.$get({ query: args }).then((r) => formatClientResponse(r)),
  })

export const useFindLogs = (
  args: FindLogsArgs,
  options?: Partial<ReturnType<typeof findLogsQueryOptions>>
) =>
  useQuery({
    ...findLogsQueryOptions(args),
    ...options,
  })
